<template>
    <div id="request-document-list">
        <div slot="no-body" class="tabs-container">
            <vs-table ref="table" search stripe :data="documents" noDataText="No hay datos disponibles">
                <template slot="header">
                    <h5 class="mr-4">Lista.</h5>
                    <vs-button @click="reloadDocumentStatus()" size="small">Actualizar</vs-button>
                </template>
                <template slot="thead">
                    <vs-th v-for="(col, idx) in columns" v-bind:key="idx"
                        :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr v-for="(tr, index) in data" :key="index">
                        <vs-td>{{ tr.doc.formField.doc_id }}</vs-td>
                        <vs-td>
                                {{ tr.n }}
                            </vs-td>
                            <vs-td>
                                <vs-chip :color="tr.color">
                                    {{ tr.e }}
                                </vs-chip>
                            </vs-td>
                            <vs-td>
                                {{ tr.section_id }} - {{ tr.section_name }}
                            </vs-td>
                            <vs-td>
                                {{ tr.is_required == 1 ? 'Si' : 'No' }}
                            </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";

const columns = [
    { title: "DOC ID", key: "doc_id", sortable: true },
    { title: "DOCUMENTO", key: "complete_name", sortable: true },
    { title: "ESTADO", key: "status", sortable: true },
    { title: "SECCIÓN", key: "location", sortable: false },
    { title: "REQUERIDO", key: "location", sortable: false },
];

export default {
    name: "DocumentList",
    props: {
        documents: Array,
        projectId: String|Number
    },
    mixins: [formatHelper],
    data: () => ({
        columns: columns
    }),
    methods: {
        getDocStatus(doc) {
            const data = {
                status: "Sin cargar",
                color: "black"
            }

            if(doc.loadedState != null) {
                const loadState = doc.loadedState;
                if(loadState.is_verified == "sin verificar") {
                    data.color = "warning bold";
                } else if(loadState.is_verified == "verificado") {
                    data.color = "success bold";
                } else if(loadState.is_verified == "rechazado") {
                    data.color = "danger bold";
                }

                data.status = loadState.is_verified != undefined ? loadState.is_verified.toUpperCase() : "Sin cargar";
            }

            return data;
        },
        reloadDocumentStatus() {
            this.$emit("updated");
        }
    }
}
</script>